import { Link } from "react-router-dom";

/**
 * Editorial invitation block for the institutional Home landing.
 * Sits between Manifesto and Atmosphere as a quiet chapter, respecting
 * the site's identity — no promotional language, no urgency.
 */
export const MacdConnectInvite = () => {
  return (
    <section
      id="macd-connect"
      data-testid="macd-connect-invite"
      className="bg-[#0a0a0a] text-white py-24 md:py-32 relative overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-7 reveal">
          <div className="flex items-center gap-4 mb-8">
            <span className="rule-yellow" />
            <span className="eyebrow text-white/60">
              MACD Connect Presencial · 17 · Ago · 2026
            </span>
          </div>

          <h2 className="font-display leading-[1.02] tracking-tight">
            <span className="block text-[#f4c542] text-5xl md:text-7xl lg:text-[6rem]">
              MACD Connect
            </span>
            <span className="block mt-6 font-display text-2xl md:text-3xl lg:text-4xl leading-[1.1] tracking-tight text-white">
              A técnica continua importante.
            </span>
            <span className="block mt-2 font-display text-2xl md:text-3xl lg:text-4xl leading-[1.1] tracking-tight text-white/85">
              <em className="italic">
                Mas ela não decide mais sozinha quem cresce.
              </em>
            </span>
          </h2>

          <p className="mt-10 max-w-xl text-base md:text-lg leading-relaxed text-white/75">
            Um dia inteiro sobre negócio e comportamento — reunidos no mesmo
            palco. <em className="italic text-white">Presencial. São Paulo.</em>
          </p>

          <div className="mt-10 flex flex-col gap-2">
            <span
              data-testid="macd-invite-dates"
              className="font-display text-2xl md:text-3xl tracking-tight"
            >
              31 <em className="italic">de agosto de 2026</em>
            </span>
            <span
              data-testid="macd-invite-time"
              className="eyebrow text-[#f4c542]"
            >
              Das 10h às 18h30
            </span>
            <span className="eyebrow text-white/55">
              São Paulo · Presencial · 40 vagas · R$ 97
            </span>
          </div>

          <div className="mt-12 flex flex-wrap items-center gap-6">
            <Link
              to="/macd-connect"
              data-testid="macd-invite-cta"
              className="btn-primary"
            >
              Conhecer o MACD Connect
              <span aria-hidden>→</span>
            </Link>
            <Link
              to="/macd-connect"
              data-testid="macd-invite-secondary"
              className="text-link-arrow is-light"
            >
              Ver programação e vagas
              <span aria-hidden className="arrow">→</span>
            </Link>
          </div>
        </div>

        <div className="lg:col-span-5 reveal">
          <div className="border border-white/12 bg-white/[0.02] p-8 md:p-10">
            <p className="eyebrow text-[#f4c542]">Os quatro pilares</p>
            <ul className="mt-8 divide-y divide-white/10">
              {[
                { letter: "M", name: "Marketing" },
                { letter: "A", name: "Autoconhecimento" },
                { letter: "C", name: "Ciência do Cabelo" },
                { letter: "D", name: "Desenvolvimento Cognitivo" },
              ].map((p) => (
                <li
                  key={p.letter}
                  className="flex items-baseline gap-6 py-4 first:pt-0 last:pb-0"
                >
                  <span className="font-display text-3xl md:text-4xl text-[#f4c542] leading-none w-6">
                    {p.letter}
                  </span>
                  <span className="font-display text-lg md:text-xl tracking-tight">
                    {p.name}
                  </span>
                </li>
              ))}
            </ul>
            <p className="mt-8 pt-6 border-t border-white/10 font-display italic text-lg md:text-xl leading-snug text-white/85">
              &ldquo;Quem mais cresce aperfeiçoa a estratégia.&rdquo;
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
